import { ServiceOptionActionTypes } from "./constants";

const INIT_STATE = {
    serviceOption: [],
    loading: true,
    error: null
};

const ServiceOption = ( state = INIT_STATE, action ) => {
    switch(action.type) {
        case ServiceOptionActionTypes.API_RESPONSE_SUCCESS:
            switch(action.payload.actionType) {
                case ServiceOptionActionTypes.GET_SERVICE_OPTION: {
                    return {
                        ...state,
                        serviceOption: action.payload.data.data,
                        loading: false,
                        error: null,
                    }
                }
                default:
                    return { ...state }
            }
        case ServiceOptionActionTypes.API_RESPONSE_ERROR:
            switch(action.payload.actionType) {
                case ServiceOptionActionTypes.GET_SERVICE_OPTION: {
                    return {
                        ...state,
                        error: action.payload.error,
                        loading: false,
                    }
                }
                default:
                    return { ...state }
            }

        case ServiceOptionActionTypes.RESET_SERVICE_OPTION:
            return { ...state, error: null }

        default:
            return { ...state }
    }
};

export default ServiceOption;